module.exports = __webpack_public_path__ + "static/media/zan-mad.22c572be.png";